export enum WorkSubmissionID {
    ICE = "ICES",
    ISWC = "ISWC",
    CisNet = "CisNet",
    WID = "WID",
    WIDACK = "WIDACK"
}